// Bulgaria adopted the euro on 1 January 2026. Transactions still carry the
// currency code "BGN" in the database, but everything charged from that date
// on is in EUR -- so that is what we show. Earlier transactions really were
// in leva and keep BGN.
export const EURO_ADOPTION_DATE = "2026-01-01";

export function displayCurrency(
  currency: string | null | undefined,
  insertedAt?: string | null,
): string {
  const code = (currency ?? "").toUpperCase();
  if (code === "BGN" && insertedAt && insertedAt.slice(0, 10) >= EURO_ADOPTION_DATE) {
    return "EUR";
  }
  return code;
}

// For things without a date of their own (machines, POS terminals, QR codes,
// current totals): their currency as of today.
export function currentCurrency(currency: string | null | undefined): string {
  return displayCurrency(currency, new Date().toISOString());
}
